<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <div>{{this.$route.query.type}} Activity</div>
                        </div>
                    </div>
                </div>
            </h2>
            <div class="view-lead-bg pb-10" style="border-top-left-radius: 6px;">
                <div class="d-flex align-items-center mb-5 px-8">
                    <div class="d-flex align-items-center flex-grow-1">
                        <div class="symbol symbol-45px me-5">
                            <img v-if="this.$route.query.profile_pic" :src="this.$route.query.profile_pic" :alt="this.$route.query.name" />
                            <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/No%20Picture.svg" alt="">
                        </div>
                        <div class="d-flex flex-column">
                            <a href="javascript:;" class="fs-16 fw-600 pb-5 text-gray-800 text-decoration-none">{{this.$route.query.name}}</a>
                            <span class="fs-14 fw-600">{{this.$route.query.type}}</span>
                        </div>
                    </div>
                </div>
                <div class="main-div pb-0">
                    <div class="create-company-header d-flex align-items-center justify-content-between">
                        <span class="fs-14 ml-3 pl-7 text-white fw-500">Activity Log</span>
                        <span class="float-right">
                            <!-- <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                <div class="d-flex justify-content-between align-items-center"
                                    style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                    <input type="text"
                                        :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                        style="color: #fff; background: #41b883; width: 14em;" disabled />
                                    <span
                                        @click="dataClose, dateRange=[]"
                                        style="color: #fff; cursor: pointer;">&#10005;</span>
                                </div>
                            </div> -->
                            <date-picker v-model="dateRange" format="DD/MM/YYYY"
                                    range @change="ConvertDate" class="date-width white-datepicker callreport-listdate calendar-height-top" :show-second="false"  :disabled-dates="disableDateRange"
                                :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                            </date-picker>
                        </span>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                </div>
                <div v-else-if="!ajaxCallInProgress && interactions.length == 0" 
                class="contentCenter mt-11 d-flex align-items-center justify-content-center h-100 fw-600 w-100">
                    No Activities
                </div>
                <div v-else-if="!ajaxCallInProgress && interactions.length && this.$route.query.type == 'Lead'">
                    <el-container v-if="interactions.length" class="outlet-details-c-el-container" style="overflow: auto">
                        <div class="lead-aside" style="width:480px !important;" @scroll="LeadinfiniteScroll">
                            <h6 class="new-blue-text fw-500 pt-4 pl-5">Lead Tracking</h6>
                            <ul class="timeline mt-10">
                                <li class="event justify-content-between align-items-center"
                                    :class="{'event-completed':interaction.details.title == 'Stage Completed'}"
                                    v-for="(interaction,index) in interactions" :key="index">
                                    <div class="mb-2 lead-status pt-2 pl-4 pr-4 pointer"
                                        :class="{'lead-status-active':interaction.id == selected_id}"
                                        @click="getLeadsDetails(interaction)">
                                        <div class="mt-1">
                                            <div class="fw-600 fs-14 text-black mb-1 text-capitalize">
                                                {{interaction.activity_name == "mark_stage_complete" ? interaction.stage_name.replace(/_/g, " ") : interaction.activity_name.replace(/_/g, " ")}}
                                            </div>
                                            <span class="fw-500"
                                                style="color: #707070;">{{interaction.details.title.replace(/_/g, " ")}}</span>
                                        </div>
                                        <div class="lead-time mt-1">{{interaction.created_date}} |
                                            {{interaction.created_time_format}}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <el-main class="pl-10 pt-15">
                            <div v-if="reminder_data">
                                <div v-if="reminder_data_created.hasOwnProperty('remind_date')">
                                    <div>
                                        <span class="new-blue-text fw-500 fs-14">Reminder title:</span>
                                        <span class="fw-500 fs-14">{{reminder_data_created.reminder_title}}</span>
                                    </div>
                                    <div class="mt-4" >
                                        <div class="new-blue-text fw-500 fs-14">Schedule Reminder At</div>
                                        <div class="fw-500 mt-4 fs-14">Date: {{reminder_data_created.remind_date}}</div>
                                        <div class="fw-500 mt-2 fs-14">Time: {{reminder_data_created.remind_time}}</div>
                                    </div>
                                    <div class="mt-4" >
                                        <div class="new-blue-text fw-500 fs-14">Repeat</div>
                                        <div class="fw-500 mt-4 fs-14">Start Date: {{reminder_data_created.repeat_start_date}}</div>
                                        <div class="fw-500 mt-2 fs-14">End Date: {{reminder_data_created.repeat_end_date}}</div>
                                        <div class="fw-500 mt-2 fs-14">Cycle: Every {{reminder_data_created.repeat_cycle_period}}
                                            {{reminder_data_created.repeat_cycle_type}}</div>
                                    </div>
                                    <div class="mt-4" >
                                        <div class="new-blue-text fw-500 fs-14">Description</div>
                                        <div class="fw-500 fs-14 break-word">{{reminder_data_created.description}}</div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div>
                                        <span class="new-blue-text fw-500 fs-14">Reminder title:</span>
                                        <span class="fw-500 fs-14">{{reminder_data_created.reminder_title}}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div v-if="note_data">
                                <div class="mt-4">
                                    <div class="new-blue-text fw-500 fs-14">Note</div>
                                    <div class="fw-500 fs-14">{{note_data.value.note}}</div>
                                </div>
                            </div>
                            <div v-if="call_report_data">
                                <div >
                                    <span class="new-blue-text fw-500 fs-14">Call Report Number:</span>
                                <!-- <span v-if="action_type == 'removed'" class="fw-500 fs-14">{{call_report_data.value}}</span>
                                    <span v-else class="fw-500 fs-14">{{call_report_data.value.report_number}}</span>-->

                                    <span class="fw-500 fs-14">{{call_report_data.value.report_number}}</span>
                                    <button v-if="call_report_data.value.report_id && action_type != 'removed'" class="add-data btn btn-secondary btn-smm d-block ml-3 pull-right" style="margin-top: -8px;border-radius:6px !important" @click="viewLeadsCallReport(call_report_data.value.report_id)"  type="button">View Call Report</button>
                                    <!--<span class="pointer mt-2" @click="viewLeadsCallReport(call_report_data.call_report_id)">
                                        <i class="icon icon-eye new-blue-text ml-3 " style="font-size:18px"></i>
                                    </span>-->
                                </div>
                            </div>
                            <div v-if="meeting_data">
                                <div v-if="meeting_data_created.hasOwnProperty('schedule_start_date')">
                                    <div>
                                        <span class="new-blue-text fw-500 fs-14">Meeting title:</span>
                                        <span class="fw-500 fs-14">{{meeting_data_created.meeting_title}}</span>
                                    </div>
                                    <div class="mt-4">
                                        <div class="fw-500 mt-4 fs-14">Schedule Start Date: {{meeting_data_created.schedule_start_date}}
                                        </div>
                                        <div class="fw-500 mt-2 fs-14">Schedule Start Time: {{meeting_data_created.schedule_start_time}}
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="fw-500 mt-4 fs-14">Schedule End Date: {{meeting_data_created.schedule_end_date}}</div>
                                        <div class="fw-500 mt-2 fs-14">Schedule End Time: {{meeting_data_created.schedule_end_time}}</div>
                                    </div>
                            
                                    <div class="mt-4">
                                        <div class="fw-500 mt-4 fs-14">Location: {{meeting_data_created.location}}1</div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="new-blue-text fw-500 fs-14">Description</div>
                                        <div class="fw-500 fs-14 break-word">{{meeting_data_created.description}}</div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div>
                                        <span class="new-blue-text fw-500 fs-14">Reminder title:</span>
                                        <span class="fw-500 fs-14">{{meeting_data_created.meeting_title}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activity_name == 'pitching'">
                                <h5 class="new-blue-text fw-600">Pitching Stage Completed</h5>
                                <div class="mt-5">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/pitching.svg">
                                </div>
                            </div>
                            <div v-if="activity_name == 'follow-up'">
                                <h5 class="new-blue-text fw-600">Follow Ups Stage Completed</h5>
                                <div class="mt-5">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/follow_ups.svg">
                                </div>
                            </div>
                            <div v-if="activity_name == 'induction'">
                                <h5 class="new-blue-text fw-600">Induction Stage Completed</h5>
                                <div class="mt-5">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/induction.svg">
                                </div>
                            </div>
                            <div v-if="activity_name == 'closure'">
                                <h5 class="new-blue-text fw-600">Closure Stage Completed</h5>
                                <div class="mt-5">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/closure.svg">
                                </div>
                            </div>
                            <div v-if="activity_name == 'changed_lead_status'">
                                <h5 class="new-blue-text fw-600 text-capitalize">{{lead_status}}</h5>
                            </div>
                        </el-main>
                    </el-container>
                    <h6 v-else class="contentCenter mt-11 d-flex align-items-center justify-content-center h-100 fw-600 w-100">
                        No Activities
                    </h6>
                </div>
                <div v-else-if="!ajaxCallInProgress && interactions.length && this.$route.query.type == 'Customer'">
                    <el-container v-if="interactions.length" class="outlet-details-c-el-container" style="overflow: auto">
                        <div class="lead-aside" style="max-width: 680px !important;min-width: 400px !important;" @scroll="CustomerinfiniteScroll">
                            <h6 class="new-blue-text fw-500 pt-4 pl-5">Customer Tracking</h6>
                            <ul class="timeline mt-10">
                                <li class="event justify-content-between align-items-center"
                                    v-for="(interaction,index) in interactions" :key="index">
                                    <div class="mb-2 lead-status pt-2 pl-4 pr-4 pointer"
                                        :class="{'customer-status-active':index == selected_id}"
                                        @click="getCustomerDetails(interaction, index)">
                                        <div class="mt-1">
                                            <div class="fw-600 fs-14 text-black mb-1 text-capitalize">
                                                {{interaction.action_type == 'remove' ? `${interaction.action_type}d` : interaction.action_type == 'create' ? 'Added' : `${interaction.action_type}ed`}}
                                                {{interaction.name == 'call_report' ? 'Call Report' : interaction.name}}
                                            </div>
                                            <div class="fs-12 overflowing-broken-text fw-500" style="color: #707070;">
                                                {{interaction.name == 'call_report' ? `${interaction.content.call_report_number}` : interaction.name == 'note' ? `${interaction.content.note}` : `${interaction.content.title}`}}
                                            </div>
                                        </div>
                                        <div class="lead-time mt-1 fs-12">{{interaction.created_date}} |
                                            {{interaction.created_time_format}}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <el-main class="pl-10 pt-15">
                            <div v-if="details_loader">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                    style="margin: 0 auto;" />
                            </div>
                            <div v-else>
                                <!-- Reminder -->
                                <div v-if="show_reminder_details">
                                    <div v-if="reminder_details">
                                        <div>
                                            <span class="new-blue-text fw-500 fs-14">Reminder title:</span>
                                            <span class="fw-500 fs-14">{{reminder_details.title}}</span>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Schedule Reminder At</div>
                                            <div class="fw-500 mt-4 fs-14">Date: {{reminder_details.remind_date}}</div>
                                            <div class="fw-500 mt-2 fs-14">Time: {{reminder_details.remind_time}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Repeat: </div>
                                            <div class="fw-500 mt-4 fs-14">Start Date:
                                                {{reminder_details.repeat_start_date || '-'}}</div>
                                            <div class="fw-500 mt-2 fs-14">End Date: {{reminder_details.repeat_end_date || '-'}}
                                            </div>
                                            <div class="fw-500 mt-2 fs-14">Cycle: Every
                                                {{reminder_details.repeat_cycle_period || '-'}}
                                                {{reminder_details.repeat_cycle_type}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Description</div>
                                            <div class="fw-500 fs-14 break-word">{{reminder_details.description || '-'}}</div>
                                        </div>
                                    </div>
                                    <div v-else class="fw-500 fs-14">This Reminder has been deleted</div>
                                </div>
                                <!-- Note -->
                                <div v-if="show_notes_details">
                                    <div class="mt-4" v-if="notes_details">
                                        <div class="new-blue-text fw-500 fs-14">Note</div>
                                        <div class="fw-500 fs-14">{{notes_details.note}}</div>
                                    </div>
                                    <div v-else class="fw-500 fs-14">
                                        This Note has been Deleted
                                    </div>
                                </div>
                                <!-- Call Report -->
                                <div v-if="show_call_reports_details">
                                    <div v-if="call_reports_details">
                                        <span class="new-blue-text fw-500 fs-14">Call Report Number:</span>
                                        <span class="fw-500 fs-14">{{call_reports_details.call_report_number}}</span>
                                        <button class="add-data btn btn-secondary btn-smm d-block ml-3 pull-right"
                                            style="margin-top: -8px;border-radius:6px !important" v-if="call_reports_details.call_report_stage != 'remove'"
                                            @click="viewLeadsCallReport(call_reports_details.call_report_id)" type="button">View
                                            Call Report</button>
                                    </div>
                                    <div v-else class="fw-500 fs-14">
                                        This Call Report has been deleted
                                    </div>
                                </div>
                                <!-- Meeting -->
                                <div v-if="show_meeting_details">
                                    <div v-if="meeting_details">
                                        <div>
                                            <span class="new-blue-text fw-500 fs-14">Meeting title:</span>
                                            <span class="fw-500 fs-14">{{meeting_details.title}}</span>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">Schedule Start Date: {{meeting_details.start_date}}
                                            </div>
                                            <div class="fw-500 mt-2 fs-14">Schedule Start Time:
                                                {{meeting_details.start_time || '-'}}
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">Schedule End Date: {{meeting_details.end_date}}</div>
                                            <div class="fw-500 mt-2 fs-14">Schedule End Time:
                                                {{meeting_details.end_time || '-'}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">
                                                Schedule All Day:
                                                <span v-if="meeting_details.all_day"> Yes</span>
                                                <span v-else> No</span>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">Location: {{meeting_details.location || '-'}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Description</div>
                                            <div class="fw-500 fs-14 break-word">{{meeting_details.description || '-'}}</div>
                                        </div>
                                    </div>
                                    <div v-else class="fw-500 fs-14">
                                        This Meeting has been deleted
                                    </div>
                                </div>
                            </div>
                        </el-main>
                    </el-container>
                </div>
                <div v-else-if="!ajaxCallInProgress && interactions.length && this.$route.query.type == 'Contact'">
                    <el-container v-if="interactions.length" class="outlet-details-c-el-container" style="overflow: auto">
                        <div class="lead-aside" style="width:480px !important;" @scroll="ContactinfiniteScroll">
                            <h6 class="new-blue-text fw-500 pt-4 pl-5">Contact Tracking</h6>
                            <ul class="timeline mt-10">
                                <li class="event justify-content-between align-items-center"
                                    v-for="(interaction,index) in interactions" :key="index">
                                    <div class="mb-2 lead-status pt-2 pl-4 pr-4 pointer"
                                        :class="{'customer-status-active':index == selected_id}"
                                        @click="getContactDetails(interaction, index)">
                                        <div class="mt-1">
                                            <div class="fw-600 fs-14 text-black mb-1 text-capitalize">
                                                {{interaction.action_type == 'remove' ? `${interaction.action_type}d` : interaction.action_type == 'create' ? 'Added' : `${interaction.action_type}ed`}}
                                                {{interaction.name == 'call_report' ? 'Call Report' : interaction.name}}
                                            </div>
                                            <div class="fs-12 overflowing-broken-text">
                                                <span class="fw-500"
                                                    style="color: #707070;">{{interaction.name == 'call_report' ? `${interaction.content.call_report_number}` : interaction.name == 'note' ? `${interaction.content.note}` : `${interaction.content.title}`}}</span>
                                            </div>
                                        </div>
                                        <div class="lead-time mt-1 fs-12">{{interaction.created_date}} |
                                            {{interaction.created_time_format}}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <el-main class="pl-10 pt-15">
                            <div v-if="details_loader">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                    style="margin: 0 auto;" />
                            </div>
                            <div v-else>
                                <!-- Reminder -->
                                <div v-if="show_reminder_details">
                                    <div v-if="reminder_details">
                                        <div>
                                            <span class="new-blue-text fw-500 fs-14">Reminder title:</span>
                                            <span class="fw-500 fs-14">{{reminder_details.title}}</span>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Schedule Reminder At</div>
                                            <div class="fw-500 mt-4 fs-14">Date: {{reminder_details.remind_date}}</div>
                                            <div class="fw-500 mt-2 fs-14">Time: {{reminder_details.remind_time}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Repeat: </div>
                                            <div class="fw-500 mt-4 fs-14">Start Date:
                                                {{reminder_details.repeat_start_date || '-'}}</div>
                                            <div class="fw-500 mt-2 fs-14">End Date: {{reminder_details.repeat_end_date || '-'}}
                                            </div>
                                            <div class="fw-500 mt-2 fs-14">Cycle: Every
                                                {{reminder_details.repeat_cycle_period || '-'}}
                                                {{reminder_details.repeat_cycle_type}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Description</div>
                                            <div class="fw-500 fs-14 break-word">{{reminder_details.description || '-'}}</div>
                                        </div>
                                    </div>
                                    <div v-else class="fw-500 fs-14">This Reminder has been deleted</div>
                                </div>
                                <!-- Note -->
                                <div v-if="show_notes_details">
                                    <div class="mt-4" v-if="notes_details">
                                        <div class="new-blue-text fw-500 fs-14">Note</div>
                                        <div class="fw-500 fs-14 break-word">{{notes_details.note}}</div>
                                    </div>
                                    <div v-else class="fw-500 fs-14">
                                        This Note has been Deleted
                                    </div>
                                </div>
                                <!-- Call Report -->
                                <div v-if="show_call_reports_details">
                                    <div v-if="call_reports_details">
                                        <span class="new-blue-text fw-500 fs-14">Call Report Number:</span>
                                        <span class="fw-500 fs-14">{{call_reports_details.call_report_number}}</span>
                                        <button class="add-data btn btn-secondary btn-smm d-block ml-3 pull-right" 
                                            style="margin-top: -8px;border-radius:6px !important" v-if="call_reports_details.action_type != 'remove'"
                                            @click="viewLeadsCallReport(call_reports_details.call_report_id)" type="button">View
                                            Call Report</button>
                                    </div>
                                    <div v-else class="fw-500 fs-14">
                                        This Call Report has been deleted
                                    </div>
                                </div>
                                <!-- Meeting -->
                                <div v-if="show_meeting_details">
                                    <div v-if="meeting_details">
                                        <div>
                                            <span class="new-blue-text fw-500 fs-14">Meeting title:</span>
                                            <span class="fw-500 fs-14">{{meeting_details.title}}</span>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">Schedule Start Date: {{meeting_details.start_date}}
                                            </div>
                                            <div class="fw-500 mt-2 fs-14">Schedule Start Time:
                                                {{meeting_details.start_time || '-'}}
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">Schedule End Date: {{meeting_details.end_date}}</div>
                                            <div class="fw-500 mt-2 fs-14">Schedule End Time:
                                                {{meeting_details.end_time || '-'}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">
                                                Schedule All Day:
                                                <span v-if="meeting_details.all_day"> Yes</span>
                                                <span v-else> No</span>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="fw-500 mt-4 fs-14">Location: {{meeting_details.location || '-'}}</div>
                                        </div>
                                        <div class="mt-4">
                                            <div class="new-blue-text fw-500 fs-14">Description</div>
                                            <div class="fw-500 fs-14 break-word">{{meeting_details.description || '-'}}</div>
                                        </div>
                                    </div>
                                    <div v-else class="fw-500 fs-14">
                                        This Meeting has been deleted
                                    </div>
                                </div>
                            </div>
                        </el-main>
                    </el-container>
                </div>
                <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
                <view-leads-call-report :view_call_report_id="view_call_report_id" @selectedCallReports="selectedCallReports" v-if="show_view_call_reports" @hideViewCallReperts="hideViewCallReports" modal_name="view_leads_call_report"></view-leads-call-report> 
            </div>
        </div>
    </div>
</template>
<script>
const uuid = require('uuidv4');
import moment from "moment";
import leads from "../mixins/leads"
import customer from '../mixins/customer'
import contacts from '../mixins/contacts'
import convert from "../mixins/convert"
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from "../eventBus/nav-bar-event.js";
import {
    HalfCircleSpinner
} from "epic-spinners";
const ViewLeadsCallReport = () => import("../Leads/ViewLeadsCallReport.vue")
export default {
    data() {
        return {
            // Customers
            notes_data: null,
            call_reports_data: null,
            meeting_details: null,
            notes_details: null,
            reminder_details: null,
            call_reports_details: null,
            show_meeting_details: false,
            show_notes_details: false,
            show_reminder_details: false,
            show_call_reports_details: false,
            details_loader: false,
            // Leads
            show_view_call_reports: false,
            view_call_report_id:'',
            warning_msg:'',
            interactions: [],
            selected_data: false,
            meeting_data: null,
            reminder_data: null,
            note_data: null,
            call_report_data: null,
            activity_name: "",
            action_type:"",
            selected_id: null,
            lead_status: null,
            current_lead_type: "",
            ajaxCallInProgress: false,
            interaction_count : 0,
            interaction_scroll: 0,
            reminder_data_created:null,
            meeting_data_created:null,
            dateRange: [],
            temp_date_range: [],
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now();
                }
            },
            lang: {
                type: "en",
                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days"
                ],
                placeholder: {
                    date: "Select Date",
                    dateRange: "Select Date Range"
                },

            },
        }
    },
    mixins: [leads, convert, customer, contacts],
    methods: {
        ConvertDate(){
            this.temp_date_range = []
            this.dateRange.forEach((el) => {
                let d = moment(el).format('YYYY-MM-DD')
                this.temp_date_range.push(d)
            })
            if(this.$route.query.type == 'Lead'){
                this.loadLeadInteraction()
            } else if(this.$route.query.type == 'Contact'){
                this.loadContactInteractionsData();
            } else if(this.$route.query.type == 'Customer'){
                this.loadCustomerInteractionsData();
            }
        },
        viewLeadsCallReport(id){
            if(!this.userPermissions.call_reports.permitted_actions.view || !this.userPermissions.draft_call_reports.permitted_actions.view) {
                this.$toasted.global.error("Permission Denied")
            } else {
                this.view_call_report_id = null
                if(id){
                    this.view_call_report_id = id
                }
                this.show_view_call_reports = true
                setTimeout(() => {
                    this.$modal.show("view_leads_call_report")
                }, 500);
            }
        },
        selectedCallReports(value){
            this.selected_call_reports = value
        },
        hideViewCallReports(){
            this.show_view_call_reports = false
        },
        async LeadinfiniteScroll(e) {
            const {
                target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    //this.ajaxCallInProgress = true
                    let params = {
                        skip: this.interaction_count ,
                        limit: 10,
                        sort_value: 1,
                        sort_key: "id",
                        lead_id: this.$route.params.id,
                        filter_json: {
                            date_range: this.temp_date_range
                        }
                    }
                    let type = this.$route.query.level;
                    let response
                    if (type == 'active_lead') {
                        response = await this.getLeadInteraction(params)
                    } else if (type == 'converted_lead') {
                        response = await this.getConvertedLeadInteraction(params)
                    } else if(type == 'archive_lead'){
                        response = await this.getArchiveLeadInteraction(params)
                    }
                    response = response.response
                    
                    if (response.skip == this.interaction_count) {
                        let tempFiles = response.interaction
                        tempFiles.forEach(x => {
                            // x["unique_id"] = uuid
                            x['created_time_format'] = new Date(x.created_time)
                            x['created_date'] = new Date(x.created_time)
                            x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })
                            var date = new Date(x.created_time_format);
                            var hours = date.getHours();
                            var minutes = date.getMinutes();

                            // Check whether AM or PM
                            var newformat = hours >= 12 ? 'PM' : 'AM';

                            // Find current hour in AM-PM Format
                            hours = hours % 12;

                            // To display "0" as "12"
                            hours = hours ? hours : 12;
                            minutes = minutes < 10 ? '0' + minutes : minutes;
                            x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                        })
                        tempFiles.forEach(el => {
                            this.interactions.push(el)
                        })
                        this.interactions = this.interactions.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.interactions.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.interaction_count += response.interaction.length
                        //this.ajaxCallInProgress = false
                    }
                } catch (reason) {
                    // console.log(reason)
                }
            }
        },
        disableDateRange(){
            const today = new Date();
            var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
            return date < today && date >today.setTime(today.getTime() - dateOffset)
        },
        async loadLeadInteraction() {
            this.ajaxCallInProgress = true
            let params = {
                skip: 0,
                limit: 10,
                sort_value: 1,
                sort_key: "id",
                lead_id: this.$route.params.id,
                filter_json: {
                    date_range: this.temp_date_range
                }
            }
            let type = this.$route.query.level;
            let response
            if (type == 'active_lead') {
                response = await this.getLeadInteraction(params)
            } else if (type == 'converted_lead') {
                response = await this.getConvertedLeadInteraction(params)
            } else if(type == 'archive_lead'){
                response = await this.getArchiveLeadInteraction(params)
            }
            this.interactions = response.response.interaction
            this.interaction_count = this.interactions.length
            this.interactions.forEach(x => {
                // x["unique_id"] = uuid
                x['created_time_format'] = new Date(x.created_time)
                x['created_date'] = new Date(x.created_time)
                x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                })
                var date = new Date(x.created_time_format);
                var hours = date.getHours();
                var minutes = date.getMinutes();

                // Check whether AM or PM
                var newformat = hours >= 12 ? 'PM' : 'AM';

                // Find current hour in AM-PM Format
                hours = hours % 12;

                // To display "0" as "12"
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                x.created_time_format = hours + ':' + minutes + ' ' + newformat;
            })
            this.ajaxCallInProgress = false
        },
        async getLeadsDetails(interaction) {
            try {
                this.ajaxCallInProgress = true
                this.selected_id = interaction.id
                this.action_type = interaction.action_type
                // console.log(this.action_type)
                if (interaction.activity_name == 'mark_stage_complete') {
                    this.note_data = null
                    this.call_report_data = null
                    this.reminder_data = null
                    this.reminder_data_created =null
                    this.meeting_data_created = null
                    this.activity_name = interaction.stage_name 
                } else {
                    this.activity_name = interaction.activity_name
                }
                if (interaction.activity_name == 'meeting') {
                    this.note_data = null
                    this.call_report_data = null
                    this.reminder_data = null
                    
                        this.reminder_data_created =null
                    let type = localStorage.getItem("leads_type");
                    /*let response
                    if (type == 'Archive') {
                        response = await this.getArchiveMeetingDetails(interaction.id)
                    } else if (type == 'Manual') {
                        response = await this.getMeetingDetails(interaction.id)
                    } else {
                        response = await this.getConvertedMeetingDetails(interaction.id)
                    }*/
                    this.meeting_data = interaction.details
                    this.meeting_data_created = interaction.details.value
                } else if (interaction.activity_name == 'note') {
                    this.meeting_data = null
                    this.call_report_data = null
                    this.reminder_data = null
                        this.reminder_data_created =null
                        this.meeting_data_created = null
                    let type = localStorage.getItem("leads_type");
                    /*let response
                    if (type == 'Archive') {
                        response = await this.getArchiveNoteDetails(interaction.id)
                    } else if (type == 'Manual') {
                        response = await this.getNoteDetails(interaction.id)
                    } else {
                        response = await this.getConvertedNoteDetails(interaction.id)
                    }*/
                    this.note_data = interaction.details
                } else if (interaction.activity_name == 'reminder') {
                    this.note_data = null
                    this.call_report_data = null
                    this.meeting_data = null
                    this.meeting_data_created = null
                    let type = localStorage.getItem("leads_type");
                    /*let response
                    if (type == 'Archive') {
                        response = await this.getRemainderArchiveDetails(interaction.id)
                    } else if (type == 'Manual') {
                        response = await this.getRemainderDetails(interaction.id)
                    } else {
                        response = await this.getRemainderConvertedDetails(interaction.id)
                    }*/
                    this.reminder_data = interaction.details
                    this.reminder_data_created = interaction.details.value
                } else if (interaction.activity_name == 'call_report') {
                    this.note_data = null
                    this.meeting_data = null
                    this.reminder_data = null
                    this.reminder_data_created =null
                    this.call_report_data = null
                        this.meeting_data_created = null
                    let type = localStorage.getItem("leads_type");
                    /*let response
                    if (type == 'Archive') {
                        response = await this.getArchiveCallReportDetails(interaction.id)
                    } else if (type == 'Manual') {
                        response = await this.getCallReportDetails(interaction.id)
                    } else {
                        response = await this.getConvertedCallReportDetails(interaction.id)
                    }*/
                    this.call_report_data = interaction.details
                } else if (interaction.action_type == 'changed_lead_status') {
                    this.activity_name = "changed_lead_status"
                    this.note_data = null
                    this.meeting_data = null
                    this.reminder_data = null
                        this.reminder_data_created =null
                    this.call_report_data = null
                        this.meeting_data_created = null
                    this.lead_status = "Changed Status from" + ' ' + interaction.activity_name.replace(/_/g, " ")
                }
                this.ajaxCallInProgress = false
            }
            catch(error) {
                this.ajaxCallInProgress = false
            }
        },
        async loadCustomerInteractionsData(){
            this.ajaxCallInProgress = true
            let params = {
                skip: 0,
                limit: 10,
                sort_value: 1,
                sort_key: "id",
                customer_id: this.$route.params.id,
                filter_json: {
                    date_range: this.temp_date_range
                }
            }
            let response = await this.getCustomerInteractionsData(params)
            this.interactions = response.response
            this.interaction_count = this.interactions.length
            this.interactions.forEach(x => {
                // x["unique_id"] = uuid
                x['created_time_format'] = new Date(x.created_time)
                x['created_date'] = new Date(x.created_time)
                x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                })
                var date = new Date(x.created_time_format);
                var hours = date.getHours();
                var minutes = date.getMinutes();

                // Check whether AM or PM
                var newformat = hours >= 12 ? 'PM' : 'AM';

                // Find current hour in AM-PM Format
                hours = hours % 12;

                // To display "0" as "12"
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                x.created_time_format = hours + ':' + minutes + ' ' + newformat;
            })
            this.ajaxCallInProgress = false
        },
        async getCustomerDetails(interaction, index){
            this.details_loader = true
            this.selected_id = index
            switch (interaction.name) {
                case 'note':
                    this.notes_details = {
                        note: interaction.content.note
                    }
                    this.show_meeting_details = false
                    this.show_notes_details = true
                    this.show_reminder_details = false
                    this.show_call_reports_details = false
                    break;
                case 'reminder':
                    this.reminder_details = {
                        created_by_name: interaction.content.created_by_name,
                        description:interaction.content.description,
                        last_modified_by: interaction.content.last_modified_by_name,
                        products: interaction.content.products,
                        remind_date: interaction.content.remind_date,
                        remind_time: interaction.content.remind_time,
                        repeat_cycle_period: interaction.content.repeat_cycle_period,
                        repeat_cycle_type: interaction.content.repeat_cycle_type,
                        repeat_end_date: interaction.content.repeat_end_date,
                        repeat_start_date: interaction.content.repeat_start_date,
                        timezone: interaction.content.timezone,
                        title: interaction.content.title
                    }
                    this.show_meeting_details = false
                    this.show_notes_details = false
                    this.show_reminder_details = true
                    this.show_call_reports_details = false
                    break;
                case 'call_report':
                    this.call_reports_details = {
                        call_report_number: interaction.content.call_report_number,
                        call_report_id: interaction.content.call_report_id,
                        created_by_name: interaction.content.created_by_name,
                        call_report_stage: interaction.action_type
                    }
                    this.show_meeting_details = false
                    this.show_notes_details = false
                    this.show_reminder_details = false
                    this.show_call_reports_details = true
                    break;
                case 'meeting':
                    this.meeting_details = {
                        all_day: interaction.content.all_day,
                        created_by_name: interaction.content.created_by_name,
                        description: interaction.content.description,
                        end_date: interaction.content.end_date,
                        end_time: interaction.content.end_time,
                        invitees: interaction.content.invitees,
                        last_modified_by_name: interaction.content.last_modified_by_name,
                        location: interaction.content.location,
                        products: interaction.content.products,
                        start_date: interaction.content.start_date,
                        start_time: interaction.content.start_time,
                        timezone: interaction.content.timezone,
                        title: interaction.content.title,
                    }
                    this.show_meeting_details = true
                    this.show_notes_details = false
                    this.show_reminder_details = false
                    this.show_call_reports_details = false
                    break;
            }
            this.details_loader = false
        },
        async CustomerinfiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
            try {
                //this.ajaxCallInProgress = true
                let params = {
                        skip: this.interaction_count,
                        limit: 10,
                        sort_value: 1,
                        sort_key: "id",
                        customer_id: this.$route.params.id,
                        filter_json: {
                            date_range: this.temp_date_range
                        }
                }
                let response = await this.getCustomerInteractionsData(params)
                response = response.response
                
                if (response.skip == this.interaction_count) {
                        let tempFiles = response.interaction
                        tempFiles.forEach(x => {
                            // x["unique_id"] = uuid
                            x['created_time_format'] = new Date(x.created_time)
                            x['created_date'] = new Date(x.created_time)
                            x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })
                            var date = new Date(x.created_time_format);
                            var hours = date.getHours();
                            var minutes = date.getMinutes();

                            // Check whether AM or PM
                            var newformat = hours >= 12 ? 'PM' : 'AM';

                            // Find current hour in AM-PM Format
                            hours = hours % 12;

                            // To display "0" as "12"
                            hours = hours ? hours : 12;
                            minutes = minutes < 10 ? '0' + minutes : minutes;
                            x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                        })
                        tempFiles.forEach(el => {
                            this.interactions.push(el)
                        })
                        this.interactions = this.interactions.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.interactions.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.interaction_count += response.interaction.length
                        // console.log(this.interaction_count)
                        //this.ajaxCallInProgress = false
                }
            } catch (reason) {
                // console.log(reason)
            }
            }
        },
        async loadContactInteractionsData() {
            this.ajaxCallInProgress = true
            let params = {
                skip: 0,
                limit: 10,
                sort_value: 1,
                sort_key: "id",
                contact_id: this.$route.params.id,
                filter_json: {
                    date_range: this.temp_date_range
                }
            }
            let response = await this.getContactsInteractionsData(params)
            this.interactions = response.response
            this.interaction_count = this.interactions.length
            this.interactions.forEach(x => {
                // x["unique_id"] = uuid
                x['created_time_format'] = new Date(x.created_time)
                x['created_date'] = new Date(x.created_time)
                x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                })
                var date = new Date(x.created_time_format);
                var hours = date.getHours();
                var minutes = date.getMinutes();

                // Check whether AM or PM
                var newformat = hours >= 12 ? 'PM' : 'AM';

                // Find current hour in AM-PM Format
                hours = hours % 12;

                // To display "0" as "12"
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                x.created_time_format = hours + ':' + minutes + ' ' + newformat;
            })
            this.ajaxCallInProgress = false
        },
        async getContactDetails(interaction, index) {
            this.details_loader = true
            this.selected_id = index
            switch (interaction.name) {
                case 'note':
                    this.notes_details = {
                        note: interaction.content.note
                    }
                    this.show_meeting_details = false
                    this.show_notes_details = true
                    this.show_reminder_details = false
                    this.show_call_reports_details = false
                    break;
                case 'reminder':
                    this.reminder_details = {
                        created_by_name: interaction.content.created_by_name,
                        description:interaction.content.description,
                        last_modified_by: interaction.content.last_modified_by_name,
                        products: interaction.content.products,
                        remind_date: interaction.content.remind_date,
                        remind_time: interaction.content.remind_time,
                        repeat_cycle_period: interaction.content.repeat_cycle_period,
                        repeat_cycle_type: interaction.content.repeat_cycle_type,
                        repeat_end_date: interaction.content.repeat_end_date,
                        repeat_start_date: interaction.content.repeat_start_date,
                        timezone: interaction.content.timezone,
                        title: interaction.content.title
                    }
                    this.show_meeting_details = false
                    this.show_notes_details = false
                    this.show_reminder_details = true
                    this.show_call_reports_details = false
                    break;
                case 'call_report':
                    this.call_reports_details = {
                        call_report_number: interaction.content.call_report_number,
                        call_report_id: interaction.content.call_report_id,
                        created_by_name: interaction.content.created_by_name,
                        action_type: interaction.action_type
                    }
                    this.show_meeting_details = false
                    this.show_notes_details = false
                    this.show_reminder_details = false
                    this.show_call_reports_details = true
                    break;
                case 'meeting':
                    this.meeting_details = {
                        all_day: interaction.content.all_day,
                        created_by_name: interaction.content.created_by_name,
                        description: interaction.content.description,
                        end_date: interaction.content.end_date,
                        end_time: interaction.content.end_time,
                        invitees: interaction.content.invitees,
                        last_modified_by_name: interaction.content.last_modified_by_name,
                        location: interaction.content.location,
                        products: interaction.content.products,
                        start_date: interaction.content.start_date,
                        start_time: interaction.content.start_time,
                        timezone: interaction.content.timezone,
                        title: interaction.content.title,
                    }
                    this.show_meeting_details = true
                    this.show_notes_details = false
                    this.show_reminder_details = false
                    this.show_call_reports_details = false
                    break;
            }
            this.details_loader = false
        },
        async ContactinfiniteScroll(e) {
            const {
                target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    //this.ajaxCallInProgress = true
                    let params = {
                        skip: this.interaction_count,
                        limit: 10,
                        sort_value: 1,
                        sort_key: "id",
                        contact_id: this.$route.params.id,
                        filter_json: {
                            date_range: this.temp_date_range
                        }
                    }
                    let response = await this.getContactsInteractionsData(params)
                    let temp_interactions = response.response
                    if (response.skip == this.interaction_count) {
                        let tempFiles = temp_interactions
                        tempFiles.forEach(x => {
                            // x["unique_id"] = uuid
                            x['created_time_format'] = new Date(x.created_time)
                            x['created_date'] = new Date(x.created_time)
                            x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric'
                            })
                            var date = new Date(x.created_time_format);
                            var hours = date.getHours();
                            var minutes = date.getMinutes();

                            // Check whether AM or PM
                            var newformat = hours >= 12 ? 'PM' : 'AM';

                            // Find current hour in AM-PM Format
                            hours = hours % 12;

                            // To display "0" as "12"
                            hours = hours ? hours : 12;
                            minutes = minutes < 10 ? '0' + minutes : minutes;
                            x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                        })
                        tempFiles.forEach(el => {
                            this.interactions.push(el)
                        })
                        this.interactions = this.interactions.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.interactions.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.interaction_count += temp_interactions.length
                        //this.ajaxCallInProgress = false
                    }
                } catch (reason) {
                    // console.log(reason)
                }
            }
        },
    },
    // beforeRouteLeave (to, from, next) {
    //     const answer = window.confirm('Do you really want to leave?');
    //     if (answer) {
    //         next()
    //     } else {
    //         next(false)
    //     }
    // },
    mounted() {
        if(this.$route.query.type == 'Lead'){
            this.current_lead_type = localStorage.getItem("leads_type")
            this.loadLeadInteraction()
        } else if(this.$route.query.type == 'Contact'){
            this.loadContactInteractionsData();
        } else if(this.$route.query.type == 'Customer'){
            this.loadCustomerInteractionsData();
        }
        EventBus.$on('RecallActivityLog', () => {
            if(this.$route.query.type == 'Lead'){
                this.current_lead_type = localStorage.getItem("leads_type")
                this.loadLeadInteraction()
            } else if(this.$route.query.type == 'Contact'){
                this.loadContactInteractionsData();
            } else if(this.$route.query.type == 'Customer'){
                this.loadCustomerInteractionsData();
            }
        })
    },
    components: {
        HalfCircleSpinner,
        ViewLeadsCallReport,
        SweetModal
    },
    computed:{
        userPermissions(){
            return this.$store.getters.userPermissions;   
        }
    },
}
</script>
<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .lead-track {
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        background-color: #fff;
    }

    .timeline {
        border-left: 2px solid #00448b;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        background: rgba(255, 255, 255, 0.03);
        color: rgba(255, 255, 255, 0.8);
        padding: 30px 48px 8px 0px !important;
        position: relative;
        line-height: 1.4em;
        overflow-x: initial;
        font-size: 14px;
        list-style: none;
        text-align: left;
        font-weight: 100;
        margin-left: 70px !important;
    }

    .timeline h3 {
        color: #303031 !important;
    }

    .timeline p {
        color: #303031 !important;
    }

    .timeline h1 {
        font-weight: 100;
        font-size: 1.4em;
    }

    .timeline h2,
    .timeline h3 {
        font-weight: 400;
        font-size: 16px;
    }

    .timeline .event {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        padding-bottom: 25px;
        margin-bottom: 25px;
        position: relative;
    }

    .timeline .event:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }

    .timeline .event:before,
    .timeline .event:after {
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event:before {
        left: -217.5px;
        color: #303031 !important;
        content: attr(data-date);
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
    }

    .timeline .event:after {
        left: -22.6px;
        background: #ffffff;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        content: "";
        top: 5px;
        border: 8px solid #00448b;
        box-shadow: 0 0 5px 0 #71acff;
    }

    .timeline .event-completed:after {
        font-family: 'fuse-iconfont';
        left: -22.6px;
        background: #34ac3d !important;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        content: "\ea7b";
        color: #fff;
        padding-top: 5px;
        font-size: 28px;
        top: 5px;
        border: 6px solid #34ac3d !important;
        box-shadow: 0 0 5px 0 #34ac3d !important;
    }

    .timeline .event .today-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event .date-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 19px;
    }

    .activityTitle {
        font-size: 14px;
        color: #4e5764 !important;
        font-weight: normal;
        position: relative;
        right: 28px;
    }

    .lead-status {
        box-shadow: 0 0 10px 0 #ededed;
        background-color: #fff;
        border-radius: 6px;
        width: 260px;
        height: 84px;
        margin-left: 35px;
        border: solid 1px transparent;
    }

    .lead-time {
        color: #837e7e;
        font-weight: 500;
    }

    .lead-aside {
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        max-height:450px!important;
        overflow:scroll
    }

    .contentCenter {
        margin: 0 auto;
    }

    .lead-status-active {
        border: solid 1px #00448b;
    }
    .flex-grow-1 {
        flex-grow: 1 !important;
    }
    .symbol {
        display: inline-block;
        flex-shrink: 0;
        position: relative;
        border-radius: 0.475rem;
    }
    .me-5 {
        margin-right: 1.25rem !important;
    }
    .symbol > img {
        width: 100%;
        flex-shrink: 0;
        display: inline-block;
        border-radius: 0.475rem;
    }
    .symbol.symbol-45px > img {
        width: 80px;
        height: 80px;
    }
    .flex-column {
        flex-direction: column !important;
    }

    .text-gray-800 {
        color: #303031 !important;
    }
    .text-decoration-none {
        text-decoration: none;
    }

    .customer-status-active {
        border: solid 1px #00448b;
    }
    .overflowing-broken-text{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .break-word{
        word-break: break-word !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Activitylogs/ActivityLog.vue